"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { createContext, useEffect, useContext } from 'react';
import { makeObservable, computed, action, observable } from 'mobx';
import { useSelector } from '../../../lib/mobx/useSelector.mjs';
import { useStatic } from '../../../lib/hooks/useStatic.mjs';

class ActionStateContext {
  states = /* @__PURE__ */ new Set();
  constructor() {
    makeObservable(this, {
      states: observable,
      addState: action,
      removeState: action,
      isBusy: computed
    });
  }
  static useNew() {
    return useStatic(() => new ActionStateContext());
  }
  static useRegisterState(state) {
    const context2 = useActionStateContext();
    useEffect(() => {
      context2?.addState(state);
      return () => {
        context2?.removeState(state);
      };
    }, [context2, state]);
  }
  addState(state) {
    this.states.add(state);
  }
  removeState(state) {
    this.states.delete(state);
  }
  useIsBusy() {
    return useSelector(() => this.isBusy);
  }
  get isBusy() {
    for (const s of this.states) {
      if (s.isBusy) {
        return true;
      }
    }
    return false;
  }
}
const context = createContext(void 0);
const ActionStateContextProvider = (props) => {
  const { children } = props;
  const ctx = ActionStateContext.useNew();
  return /* @__PURE__ */ jsx(context.Provider, { value: ctx, children });
};
const useActionStateContext = () => {
  const newContext = ActionStateContext.useNew();
  return useContext(context) ?? newContext;
};

export { ActionStateContext, ActionStateContextProvider, useActionStateContext };
//# sourceMappingURL=ActionStateContext.mjs.map
